import { Component, Input } from '@angular/core'
import { PortalGlobals } from '../../../../app/portalglobals'
@Component({
    selector: 'EnrollmentHeader',
    template: `
     <div class="row"><div class="col-24">
      <h1>Hello {{ _global.currentUser.firstName  | titlecase }}
{{ _global.currentUser.lastName | titlecase  }}. Plan Year is
 {{ _global.selectedPlanYear}}</h1>
    </div></div>
  `
})

export class EnrollmentHeaderComponent {
 @Input() UserName: string
    @Input() PlanYear: string


constructor(public _global: PortalGlobals) {
    }

}
